import { render, staticRenderFns } from "./TradeMassCloseOrderModal.vue?vue&type=template&id=3d781932&scoped=true&"
import script from "./TradeMassCloseOrderModal.vue?vue&type=script&lang=js&"
export * from "./TradeMassCloseOrderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d781932",
  null
  
)

export default component.exports